/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EquipmentPartDto } from './EquipmentPartDto';
import {
    EquipmentPartDtoFromJSON,
    EquipmentPartDtoFromJSONTyped,
    EquipmentPartDtoToJSON,
    EquipmentPartDtoToJSONTyped,
} from './EquipmentPartDto';

/**
 * 
 * @export
 * @interface UpsertEquipmentRequest
 */
export interface UpsertEquipmentRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    assetId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    equipmentTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    mineLocationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpsertEquipmentRequest
     */
    installDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    manufacturerId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertEquipmentRequest
     */
    configurationId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    partNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    capitalIndexNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEquipmentRequest
     */
    externalId?: string;
    /**
     * 
     * @type {Array<EquipmentPartDto>}
     * @memberof UpsertEquipmentRequest
     */
    equipmentParts?: Array<EquipmentPartDto>;
}

/**
 * Check if a given object implements the UpsertEquipmentRequest interface.
 */
export function instanceOfUpsertEquipmentRequest(value: object): value is UpsertEquipmentRequest {
    return true;
}

export function UpsertEquipmentRequestFromJSON(json: any): UpsertEquipmentRequest {
    return UpsertEquipmentRequestFromJSONTyped(json, false);
}

export function UpsertEquipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertEquipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'equipmentTypeId': json['equipmentTypeId'] == null ? undefined : json['equipmentTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
        'installDate': json['installDate'] == null ? undefined : (new Date(json['installDate'])),
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'partNumber': json['partNumber'] == null ? undefined : json['partNumber'],
        'capitalIndexNumber': json['capitalIndexNumber'] == null ? undefined : json['capitalIndexNumber'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'equipmentParts': json['equipmentParts'] == null ? undefined : ((json['equipmentParts'] as Array<any>).map(EquipmentPartDtoFromJSON)),
    };
}

export function UpsertEquipmentRequestToJSON(json: any): UpsertEquipmentRequest {
    return UpsertEquipmentRequestToJSONTyped(json, false);
}

export function UpsertEquipmentRequestToJSONTyped(value?: UpsertEquipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetId': value['assetId'],
        'equipmentTypeId': value['equipmentTypeId'],
        'name': value['name'],
        'description': value['description'],
        'mineLocationId': value['mineLocationId'],
        'installDate': value['installDate'] == null ? undefined : ((value['installDate']).toISOString().substring(0,10)),
        'manufacturerId': value['manufacturerId'],
        'configurationId': value['configurationId'],
        'serialNumber': value['serialNumber'],
        'partNumber': value['partNumber'],
        'capitalIndexNumber': value['capitalIndexNumber'],
        'externalId': value['externalId'],
        'equipmentParts': value['equipmentParts'] == null ? undefined : ((value['equipmentParts'] as Array<any>).map(EquipmentPartDtoToJSON)),
    };
}

